var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6249 14L17.5642 11.6857L15.2499 10.625L17.5624 9.57502L18.6249 7.25002L19.6874 9.57502L21.9999 10.625L19.6856 11.6857L18.6249 14ZM10.9999 8.85002L12.203 6.20315L14.8499 5.00002L12.203 3.7969L10.9999 1.15002L9.79678 3.7969L7.1499 5.00002L9.79678 6.20315L10.9999 8.85002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22L9.875 17.875L14 16L9.875 14.125L8 10L6.125 14.125L2 16L6.125 17.875L8 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreate);
export default __webpack_public_path__ + "static/media/icon-create.6544da8544ff2175d6c685ddd0b1b482.svg";
export { ForwardRef as ReactComponent };